<template>
  <div class="purchase-pod-subscription">
    <h2 class="purchase-pod-subscription__title">
      {{ $t('title') }}
    </h2>
    <div class="purchase-pod-subscription__plan purchase-pod-subscription__block">
      <div class="purchase-pod-subscription__sub-title">
        {{ $t('payment_title') }}
      </div>
      <div class="purchase-pod-subscription__plan-content">
        {{ productPrice }}
      </div>
    </div>

    <div class="purchase-pod-subscription__payment purchase-pod-subscription__block">
      <div class="purchase-pod-subscription__sub-title">
        {{ $t('how_title') }}
      </div>
      <div class="purchase-pod-subscription__text">
        {{ $t('how_text') }}
      </div>
    </div>

    <div class="purchase-pod-subscription__details purchase-pod-subscription__block">
      <div class="purchase-pod-subscription__sub-title">
        {{ $t('critical_title') }}
      </div>
      <div class="purchase-pod-subscription__text">
        {{ $t('critical_text') }}
      </div>
    </div>

    <div class="purchase-pod-subscription__details purchase-pod-subscription__block">
      <div class="purchase-pod-subscription__sub-title">
        {{ $t('timeline_title') }}
      </div>
      <div class="purchase-pod-subscription__text">
        {{ $t('timeline_text') }}
      </div>
    </div>

    <div class="purchase-pod-subscription__faq-link purchase-pod-subscription__block">
      <a class="purchase-pod-subscription__link" :href="cyclonFAQUrl" target="_blank">{{
        $t('faq')
      }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { formatToCurrency } from '@/helpers/currency-formatter'
import { CYCLON_FAQ_PATH } from '@/config/constants'

export default {
  name: 'Cyclon',
  computed: {
    ...mapState({
      currency: state => state.store.currency,
      locale: state => state.page.locale,
    }),
    ...mapGetters({
      variant: 'product/currentVariant',
      getFullUrl: 'page/getFullUrl',
    }),

    productPrice() {
      const amount = Number(this.variant.spreeProduct.price)
      return formatToCurrency(amount, this.locale, this.currency)
    },

    cyclonFAQUrl() {
      return this.getFullUrl(CYCLON_FAQ_PATH)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/Cyclon/cyclon-settings.scss';

.purchase-pod-subscription {
  font-family: $font-family-helvetica-now;

  &__block {
    margin-bottom: 40px;
  }

  &__title {
    @include cyclon-font;
    margin-bottom: 40px;
    font-size: $font-size-heading-large;

    @media ($tablet-breakpoint) {
      margin: -6px 0 40px;
      font-size: 48px;
    }
  }

  &__sub-title {
    @include cyclon-font;
    margin-bottom: 12px;
    font-size: $f-size-xsmall;
    line-height: $line-height;
    letter-spacing: 0.35em;
    text-transform: uppercase;
    color: $c-grey-dark-1;

    @media ($tablet-breakpoint) {
      font-size: $f-size-smaller;
      letter-spacing: 0.3em;
    }
  }

  &__text {
    font-size: $f-size-normal;
    line-height: $line-height-normal;
    color: $c-grey-dark-1;
  }

  &__link {
    font-size: $f-size-small;
    line-height: $line-height-normal;
    color: $c-grey-mid-1;
    text-decoration: underline;
  }

  &__plan-content {
    padding: 18px;
    border-radius: 1px;
    font-size: $f-size-normal;
    font-weight: 900;
    line-height: 1.166667;
    color: $c-grey-dark-1;
    background: $color-white;
  }
}

/deep/ .purchase-pod__content {
  padding-top: 0;
}
</style>

<i18n src="@/locales/purchase_pod_subscription.json"></i18n>
